import SingleDatePicker from "components/input-range-data";
import { useOfmFiltersState } from "../../ducks/filter/hooks/state";
import { useOfmFiltersActions } from "../../ducks/filter/hooks/actions";

export default function SelectFilters() {
  const { fromDate, toDate } = useOfmFiltersState();
  const { setFromDate, setToDate } = useOfmFiltersActions();

  return (
    <div className="flex flex-col gap-4">
      <div className="flex gap-4">
        <div className="flex-1">
          <SingleDatePicker
            id="from-date"
            date={fromDate || undefined}
            onDateChange={(date) => setFromDate(date || null)}
            label="De:"
          />
        </div>
        <div className="flex-1">
          <SingleDatePicker
            id="to-date"
            date={toDate || undefined}
            onDateChange={(date) => setToDate(date || null)}
            label="Até:"
          />
        </div>
      </div>
    </div>
  );
}
